import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarGraphComponent } from './bar-graph/bar-graph.component';

import { NgxEchartsModule } from 'ngx-echarts';
import { MaterialModule } from 'src/app/material/material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { NewUserMasterComponent } from './new-user-master/new-user-master.component';
import { ButtonIconModule } from '../shared/components/button-icon/button-icon.module';

@NgModule({
  declarations: [
    BarGraphComponent,
    NewUserMasterComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatDialogModule,
    ButtonIconModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    })
  ],
  exports: [
    BarGraphComponent,
    NewUserMasterComponent
  ]
})
export class ComponentsModule { }
